import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/style.scss'
import router from './router/'
import Config from './config/app'
import XLSX from "xlsx";
import Blob from './utils/excal/Blob.js'
import Export2Excel from './utils/excal/Export2Excel.js'
import {
  isLogin
}
  from './utils/dataStorage'
import {
  formatDate,
  numberFormat
} from './utils/index'
import * as echarts from 'echarts'
 
Vue.prototype.$echarts = echarts

import App from './App.vue'
import { CountDown, Badge } from 'vant';
Vue.use(CountDown)
Vue.use(Badge)
Vue.prototype.$Config = Config;

Vue.use(ElementUI)
Vue.use(XLSX)

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title ? to.meta.title + '-' + Config.siteName : Config.siteName;

  if (!isLogin() && to.path != '/login') {
    next({
      path: '/login'
    });
  } else {
    next();
  }
});
router.afterEach(transition => {

});

// router.beforeRouteLeave((to, from, next) => {
//   if (to.path === '/supplier_list') {
//     to.meta.keepAlive = true
//   } else {
//   	// 否则keepAlive设为 false
//     to.meta.keepAlive = false
//   }
//   next();
// })


Vue.filter("dateTime", function (v) {
  if (!v) return "-"
  var date = new Date(parseInt(v));
  return formatDate(date, "yyyy-MM-dd hh:mm")
})
Vue.filter("amountRMB", function (v) {
  return "￥" + numberFormat(v, 2)
})
Vue.filter("amountUSDT", function (v) {
  return (v / 100).toFixed(2)
})
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})